import { FEEDS_ROUTES } from '../../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import feedsTypes from '../../constants/feedsTypes'
import { axios } from '../../services'

// 1 publish
// 2 publish_all
// 3 unpublish
// 4 unpublish_all
// 5 update_xml

// 1 publish
const publish_feed_request = () => {
  return {
    type: feedsTypes.publish.request
  }
}

const publish_feed_success = (response) => {
  return {
    type: feedsTypes.publish.success,
    payload: response.data.feed
  }
}

const publish_feed_minimal_success = (response) => {
  return {
    type: feedsTypes.publish.success_minimal,
    payload: response.data
  }
}

const publish_feed_failure = (messages) => {
  return {
    type: feedsTypes.publish.failure,
    payload: messages
  }
}

const publish_feed = (feed_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_feed_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.publish, {id: feed_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( publish_feed_minimal_success(response) )
      } else {
        dispatch( publish_feed_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error publishing feed."]
      }
      dispatch( publish_feed_failure( errors ) )
    })
  }
}

// 2 publish_all
const publish_all_request = () => {
  return {
    type: feedsTypes.publish_all.request
  }
}

const publish_all_success = (response) => {
  return {
    type: feedsTypes.publish_all.success,
    payload: response.data
  }
}

const publish_all_failure = (messages) => {
  return {
    type: feedsTypes.publish_all.failure,
    payload: messages
  }
}

const publish_all = (feed_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_all_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.publish_all, {id: feed_id}),
      {
        page: page,
        per_page: 10
      }
    ).then( response => {
      // success
      dispatch( publish_all_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error publishing all project feeds."]
      }
      dispatch( publish_all_failure( errors ) )
    })
  }
}

// 3 UNpublish
const unpublish_feed_request = () => {
  return {
    type: feedsTypes.unpublish.request
  }
}

const unpublish_feed_success = (response) => {
  return {
    type: feedsTypes.unpublish.success,
    payload: response.data.feed
  }
}

const unpublish_feed_minimal_success = (response) => {
  return {
    type: feedsTypes.unpublish.success_minimal,
    payload: response.data
  }
}

const unpublish_feed_failure = (messages) => {
  return {
    type: feedsTypes.unpublish.failure,
    payload: messages
  }
}

const unpublish_feed = (feed_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( unpublish_feed_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.unpublish, {id: feed_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( unpublish_feed_minimal_success(response) )
      } else {
        dispatch( unpublish_feed_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error unpublishing feed."]
      }
      dispatch( unpublish_feed_failure( errors ) )
    })
  }
}

// 4 unpublish_all
const unpublish_all_request = () => {
  return {
    type: feedsTypes.unpublish_all.request
  }
}

const unpublish_all_success = (response) => {
  return {
    type: feedsTypes.unpublish_all.success,
    payload: response.data
  }
}

const unpublish_all_failure = (messages) => {
  return {
    type: feedsTypes.unpublish_all.failure,
    payload: messages
  }
}

const unpublish_all = (feed_id, page=1) => {
  return function(dispatch) {
    // Before Request
    dispatch( unpublish_all_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.unpublish_all, {id: feed_id}),
      {
        page: page,
        per_page: 10
      }
    ).then( response => {
      // success
      console.log(response)
      dispatch( unpublish_all_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        // errors = ["Error unpublishing all project feeds."]
        errors = [error]
      }
      dispatch( unpublish_all_failure( errors ) )
    })
  }
}

// 5 update_xml
const update_xml_request = () => {
  return {
    type: feedsTypes.update_xml.request
  }
}

const update_xml_success = (response) => {
  return {
    type: feedsTypes.update_xml.success,
    payload: response.data.feed
  }
}

const update_xml_minimal_success = (response) => {
  return {
    type: feedsTypes.update_xml.success_minimal,
    payload: response.data
  }
}

const update_xml_failure = (messages) => {
  return {
    type: feedsTypes.update_xml.failure,
    payload: messages
  }
}

const update_xml = (feed_id, page=1, show="standard") => {
  return function(dispatch) {
    // Before Request
    dispatch( update_xml_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.update_xml, {id: feed_id}),
      {
        page: page,
        per_page: 10,
        show: show
      }
    ).then( response => {
      // success
      if (show === "minimal") {
        dispatch( update_xml_minimal_success(response) )
      } else {
        dispatch( update_xml_success(response) )
      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [errors]
      }
      dispatch( update_xml_failure( errors ) )
    })
  }
}

const upload_new = (feed_id, formData) => {
  return function(dispatch) {
    // Before Request
    dispatch( update_xml_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.upload_new, {id: feed_id}),
      formData
    ).then( response => {
      // success
      dispatch( update_xml_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [errors]
      }
      dispatch( update_xml_failure( errors ) )
    })
  }
}

const clone_feed = (feed_id, page=1, name) => {
  return function(dispatch) {
    // Before Request
    dispatch( update_xml_request() )

    // Request
    axios.post(
      formatRoute(FEEDS_ROUTES.clone, {id: feed_id}),
      {
        page: page,
        per_page: 10,
        name: name !== undefined && name !== null ? name : ""
      }
    ).then( response => {
      // success
      dispatch( update_xml_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [errors]
      }
      dispatch( update_xml_failure( errors ) )
    })
  }
}


export {
  publish_feed,
  publish_all,
  unpublish_feed,
  unpublish_all,
  update_xml,
  upload_new,
  clone_feed
}



// WEBPACK FOOTER //
// ./src/js/actions/feeds/publish_actions.js